/** Mobile-friendly ML sheet dropdown panel — fixed width on small screens so labels are readable. */
export const ML_MOBILE_DROPDOWN_PANEL =
  'absolute z-[60] mt-1 bg-white border border-gray-300 rounded-xl shadow p-2 max-md:fixed max-md:left-3 max-md:right-3 max-md:mt-2 max-md:w-auto md:w-full'

export const ML_MOBILE_DROPDOWN_SEARCH =
  'w-full px-2 py-1.5 mb-2 border border-gray-300 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-400 text-[11px] sm:text-sm'

export const ML_MOBILE_DROPDOWN_ITEM =
  'flex items-start gap-1.5 p-1.5 max-md:p-1 hover:bg-gray-50 rounded cursor-pointer min-w-0'

export const ML_MOBILE_DROPDOWN_ITEM_TEXT =
  'min-w-0 flex-1 text-[10px] leading-snug break-words sm:text-sm sm:leading-normal'

export const ML_MOBILE_DROPDOWN_ITEM_META =
  'block text-[9px] text-gray-500 sm:text-xs sm:inline sm:ml-1'

export const ML_MOBILE_FIELD_LABEL =
  'block text-[10px] sm:text-sm font-medium text-secondary mb-1 sm:mb-2 leading-tight'

export const ML_MOBILE_TRIGGER =
  'cursor-pointer border border-gray-300 rounded-xl px-2 py-1.5 sm:px-3 sm:py-2 bg-white flex justify-between items-center gap-1 min-h-[36px] sm:min-h-[40px]'

export const ML_MOBILE_TRIGGER_OPEN =
  'border-blue-400 ring-2 ring-blue-400'

export const ML_MOBILE_TRIGGER_TEXT =
  'text-[10px] sm:text-sm text-gray-700 min-w-0 flex-1 leading-tight break-words line-clamp-2 sm:line-clamp-none sm:truncate'

export const mlMobileTriggerClass = (isOpen = false) =>
  `${ML_MOBILE_TRIGGER}${isOpen ? ` ${ML_MOBILE_TRIGGER_OPEN}` : ''}`
